import React from 'react'
import ChannelsShowContainer from './Container'
import { RedirectToFirstNote } from './RedirectToFirstNote'

type ChannelsShowProps = {
  channelId: string
  goToNotes?: boolean
}

export default function ChannelsShow({
  channelId,
  goToNotes = false,
}: ChannelsShowProps) {
  if (goToNotes) {
    return <RedirectToFirstNote channelId={channelId} />
  }

  return <ChannelsShowContainer channelId={channelId} />
}
